import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Cadeau = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 80.1">
  <G fill={color}>
    <Path d="M37.38,70.07c0,1.59-1.29,2.88-2.88,2.88s-2.88-1.29-2.88-2.88v-24.87H5.64v32.02c0,1.59,1.29,2.88,2.88,2.88h51.95c1.59,0,2.88-1.29,2.88-2.88v-32.02h-25.97v24.87Z"/>
    <Path d="M66.11,22.39h-14.89c7.12-4.23,9.35-9.17,10.04-11.73.92-3.4.25-6.6-1.74-8.34-2.14-1.87-5.52-2.68-9.05-2.17-4.73.69-9.05,3.62-11.85,8.05-1.74,2.76-3.09,5.53-4.13,7.99-1.03-2.46-2.38-5.23-4.13-7.99C27.57,3.78,23.25.84,18.52.15c-3.53-.51-6.91.3-9.05,2.17-1.99,1.74-2.66,4.94-1.74,8.34.69,2.55,2.92,7.5,10.04,11.73H2.88c-1.59,0-2.88,1.29-2.88,2.88v14.16h31.62v-6.09c0-1.59,1.29-2.88,2.88-2.88s2.88,1.29,2.88,2.88v6.09h31.62v-14.16c0-1.59-1.29-2.88-2.88-2.88ZM13.52,9.86c-.73-1.95-.35-3.06-.25-3.2.56-.49,1.7-.9,3.18-.9.39,0,.81.03,1.24.09,1.8.26,5.21,1.32,7.81,5.43,2.28,3.61,3.83,7.29,4.81,10.05-12.84-3.56-16.07-9.57-16.79-11.48ZM43.5,11.28c2.6-4.11,6.01-5.17,7.81-5.43.44-.06.85-.09,1.25-.09,1.48,0,2.61.4,3.14.86.13.17.51,1.28-.22,3.23-.72,1.91-3.95,7.92-16.79,11.48.98-2.77,2.53-6.45,4.81-10.05Z"/>
  </G>
</Svg>
);
};

export default Cadeau;
